
import { environment } from './../../../../../environments/environment';
import { Injectable } from '@angular/core';
import { JwtHelperService } from '@auth0/angular-jwt';
import { find } from 'lodash';
import { of, Observable } from 'rxjs';
import { ofType } from '@ngrx/effects';
@Injectable({
  providedIn: 'root'
})
export class RoleService {
  roles: string[] = [];
  constructor() { }

  getAllRoles() {
    try {
      const helper = new JwtHelperService();
      var token = localStorage.getItem(environment.authTokenKey);
      if (token)
        this.roles = helper.decodeToken(token)['http://schemas.microsoft.com/ws/2008/06/identity/claims/role'];
    } catch (error) {

    }

  }
  haveRole(roleName: string): boolean {
    try {
      const helper = new JwtHelperService();
      var token = localStorage.getItem(environment.authTokenKey);
      if (!token) return false;
      this.roles = helper.decodeToken(token)['http://schemas.microsoft.com/ws/2008/06/identity/claims/role'];
      return this.roles.findIndex(x => x === roleName) >= 0 ? true : false;
    } catch (error) {
      return false;
    }

  }
}
